<template>
    <div>
        <div id="main-nav-left" v-bind:class="{page : isPage}">
            <div class="row">
                <div class="col-sm-3">
        <!--             <router-link to="/artists" class="h3 nav-item" v-if="page != '/artists' && page != '/info'">Artists</router-link>
                    <router-link to="/" class="h3 nav-item" v-else-if="page == '/artists'">Editions</router-link>
                    <router-link to="/" class="h3 nav-item" v-else>Editions</router-link> -->
                    <!-- <router-link to="/"><p>Jollyfully waiting</p></router-link> -->
                </div>
            </div>
        </div>
        <div id="main-nav" v-bind:class="{page : isPage}">
            <div class="col-sm-12 no-click ">
<!--                 <div class="h2 text-center" v-if="page == '/editions'">Editions</div>
                <div class=" h2 text-center" v-else-if="page == '/artists'">Artists</div>
                <div class="h2 text-center" v-else-if="page == '/info'">
                    About  -->
                    <!--                     <div class="stage center">

                        <div v-bind:class="{'dot-2': random == 2, 'dot-2': random == 3, 'dot-1': random == 4, 'dot-4': random == 5, 'dot-5': random == 6, 'dot-6': random == 7}"></div>
                       
                    </div> -->
                <!-- </div> -->
<!--                 <div class=" h2 text-center" v-else>
                </div> -->
            </div>
        </div>
        <div id="main-nav-right" v-bind:class="{page : isPage}">
            <div class="row">
                <div class="col-12 text-right">
                    <!-- <router-link to="/info" class="nav-item h3 text-center" v-if="page != '/info'"> -->
                    <!--  <div class="snippet">
                            <div class="stage">
                                <div :class="'dot-'+random"></div>
                            </div>
                        </div> -->
                    <!-- About -->
                    <div class="frame" @click="openClose">
                        <div class="center">
                            <div id="effect-area" class="start">
                                <div id="top" class="line" :style="'background-color:'+ color">
                                </div>
                                <div id="middle" class="line" :style="'background-color:'+ color">
                                </div>
                                <div id="bottom" class="line" :style="'background-color:'+ color">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </router-link> -->
                    <!-- <router-link to="/artists" class="nav-item text-right h3" v-else> -->
                    <!-- Artists -->
                    <!-- </router-link> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Nav',
    props: ['color'],
    computed: {
        isPage() {
            return this.$store.state.isPage;
        },
        page() {
            return this.$store.state.page;
        },
        random() {
            return Math.floor(Math.random() * 5) + 1;
        },
        menuStatus() {
            return this.$store.state.menuStatus;
        }
    },
    methods: {
        openClose() {
            this.$store.commit('setMenuStatus', !this.menuStatus)
            var effect_area = document.getElementById("effect-area");
            if (!effect_area.classList.contains("effect")) {
                effect_area.classList.add("effect");
            } else {
                effect_area.classList.remove("effect");
            }
        }
    },
    watch: {
        $route(to) {
            var effect_area = document.getElementById("effect-area");
            effect_area.classList.remove("effect");
            this.$store.commit('setMenuStatus', false)
        }
    },
    components: {},
    mounted() {}
}
</script>